import React, { createContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import variable from "../lib/variable";

export const AuthContext = createContext();
const USER_SESSION_KEY = "wms-user-token";

const API_BASE_URL = process.env.REACT_APP_OLD_WMS_API_BASE_URL;

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [authUserData, setAuthUserData] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [selectedDomain, setSelectedDomain] = useState();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const hasUserData = localStorage.getItem(USER_SESSION_KEY);
    const logOutFromUrl = searchParams.get("logout");

    if (logOutFromUrl) {
      localStorage.removeItem(USER_SESSION_KEY);
      setIsAuthenticated(false);
      navigate("/login");
      setAuthLoading(false);
      return;
    }

    if (hasUserData) {
      const userData = JSON.parse(atob(hasUserData));
      //console.log(userData)
      verifyLogin(userData.auth_token);
    } else {
      setAuthLoading(false);
    }
  }, [location.search]);

  const verifyLogin = async (token) => {
    try {
      const time=Date.now();
      const response = await axios.get(`${API_BASE_URL}user/verify-login?v=${time}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = response.data.data;
      const defaultDOmain=localStorage.getItem(variable.DEFAULT_DOMAIN)
      if (data.productslist.length > 0) {
        const find=data.productslist.find(el=>el.domain_url==defaultDOmain);
        if(find){
          setSelectedDomain(find);
        }else{
        setSelectedDomain(data.productslist[0]);

        }
      }
      // ✅ If token valid
      setAuthUserData({ ...data, auth_token: token }); // user info returned by backend
      setIsAuthenticated(true);
    } catch (err) {
      console.error("Login verification failed:", err);
      localStorage.removeItem(USER_SESSION_KEY);
      setIsAuthenticated(false);
      navigate("/login");
    } finally {
      setAuthLoading(false);
    }
  };

  const logOut = () => {
    localStorage.removeItem(USER_SESSION_KEY);
    setIsAuthenticated(false);
    setAuthUserData(null);
    navigate("/login");
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        setIsAuthenticated,
        authLoading,
        authUserData,
        setAuthUserData,
        logOut,
        selectedDomain,
        setSelectedDomain
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
